import { render, staticRenderFns } from "./occpCls.vue?vue&type=template&id=2243d0cc&"
import script from "./occpCls.vue?vue&type=script&lang=js&"
export * from "./occpCls.vue?vue&type=script&lang=js&"
import style0 from "./occpCls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "occpCls.vue"
export default component.exports